import React, { FC } from 'react';
import { useReframe } from 'nike-re-framejs';
import { overviewBet$$, overviewMarket$$ } from '../push/overview/subs';
import { ChannelState, OverviewMarket } from '../dto';
import { BetAdditionalLabel, Cell, EmptyCellOverview } from './BetSelection';
import { localizeMap } from '../utils';
import { channelStatus$$ } from '../push/channelStatus/subs';
import clsx from 'clsx';
import { isMobileChannel } from '../../../common/util';

const OverviewBetPlaceholder: FC<{ count: number }> = ({ count }) => (
    <>
        {Array.from({ length: count }).map((e, i) => (
            <EmptyCellOverview key={i} />
        ))}
    </>
);

const OverviewBetContainer: FC<{ otherClass?: string; columnId: number; children: any }> = ({
    otherClass,
    columnId,
    children
}) => {
    const mobileChannel = isMobileChannel();
    return (
        <div
            className={clsx('flex flex-1 p-rel turbo-live-col', otherClass, {
                'match-bets-brg': !mobileChannel,
                'ml-20': mobileChannel && columnId !== 0
            })}
        >
            {children}
        </div>
    );
};

export interface OverviewBetProps {
    sportCode: string;
    matchId;
    marketId;
    otherClass?: string;
    columnId?: number;
}

const OverviewBet: FC<OverviewBetProps> = ({ sportCode, matchId, marketId, columnId, otherClass }) => {
    const { derefSub, subscribe } = useReframe();
    const bet = derefSub(overviewBet$$(sportCode, matchId, marketId));
    const market: OverviewMarket = subscribe(overviewMarket$$(sportCode, marketId));
    if (!market) {
        return null;
    }
    if (!bet) {
        return (
            <OverviewBetContainer otherClass={otherClass} columnId={columnId}>
                <OverviewBetPlaceholder count={market.columns} />
            </OverviewBetContainer>
        );
    }
    const channelState: ChannelState = derefSub(channelStatus$$(bet.get('channelId')));
    const additionalLabel = localizeMap(bet.getIn(['overview', 'additionalLabel']));

    return (
        <OverviewBetContainer otherClass={otherClass} columnId={columnId}>
            {additionalLabel && <BetAdditionalLabel label={additionalLabel} />}
            {market?.layout?.cells[0].map((cell, i) => (
                <Cell
                    cell={cell}
                    bet={bet}
                    channelEnabled={channelState === ChannelState.ENABLED}
                    key={i}
                    index={i}
                    columnId={columnId}
                />
            ))}
        </OverviewBetContainer>
    );
};

export default OverviewBet;
